export default import.meta.ROLLDOWN_FILE_URL_6cXPebzpyEfI166TiAsuBA